// account
export * from "./account/register.model";
export * from "./account/login.model";

// clubs
export * from "./club/create.club.model";
export * from "./club/getintouch.model";



// WEBPACK FOOTER //
// ./src/models/index.js